module.exports = __webpack_public_path__ + "static/media/skyland500.ae2565d1.png";